// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {ListLandingsScreenLayout} from 'app_components/screens/admin/landings/listLandings'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import PermissionService from 'app_services/secure/permission/permissionService'
// @end

// @import types
// @end

// @ADD Component types
interface IListLandingsScreenProps {}
interface IListLandingsScreenState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ListLandingsScreen extends Component<IListLandingsScreenProps, IListLandingsScreenState> {

  public moduleName: string = 'module:landings'
  private permission: PermissionService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IListLandingsScreenProps) {
    super(props)
    this.state = {}
    this.permission = new PermissionService(this.moduleName)
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <ListLandingsScreenLayout
        permission={this.permission}
      />
    )
  }
}

export default connect(mapStatesToProps)(ListLandingsScreen)
